/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface ClasseRemarqueSearch
 */
export interface ClasseRemarqueSearch {
    /**
     * 
     * @type {number}
     * @memberof ClasseRemarqueSearch
     */
    idClasse?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClasseRemarqueSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ClasseRemarqueSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ClasseRemarqueSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ClasseRemarqueSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ClasseRemarqueSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ClasseRemarqueSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ClasseRemarqueSearch interface.
 */
export function instanceOfClasseRemarqueSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ClasseRemarqueSearchFromJSON(json: any): ClasseRemarqueSearch {
    return ClasseRemarqueSearchFromJSONTyped(json, false);
}

export function ClasseRemarqueSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClasseRemarqueSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idClasse': !exists(json, 'idClasse') ? undefined : json['idClasse'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ClasseRemarqueSearchToJSON(value?: ClasseRemarqueSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idClasse': value.idClasse,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

